module.exports = __webpack_public_path__ + "img/deleted.8fa3156e.svg";